import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../../utils/analytics';

const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export default function RouteChangeTracker() {
	const location = useLocation();

	useEffect(() => {
		initGA(measurementId);
		// initial view
		trackPageView(location.pathname + location.search);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		trackPageView(location.pathname + location.search);
	}, [location.pathname, location.search]);

	return null;
}
